import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export interface Props {
        isInvalidCount?: boolean;
        max?: number;
        count?: number;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CharacterCount',
  props: {
    isInvalidCount: { type: Boolean, default: false },
    max: { default: 0 },
    count: { default: 0 }
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["character-count", {'invalid-character-count': _ctx.isInvalidCount}])
  }, _toDisplayString(props.count) + "/" + _toDisplayString(props.max), 3))
}
}

})